import React from 'react';
import { Grid } from '@material-ui/core';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const CountryRedirectCard = ({
    header,
    footer,
    message = [],
}) => {
    return (
        <Grid container style={{ 
            border: "1px solid #593687", 
            backgroundColor: "rgba(89, 54, 135, 0.04)", 
            borderRadius: 16,
            padding: 16,
            marginTop: 16,
            gap: 8
        }}>
            <Grid container item xs={12} style={{ flexWrap: "nowrap" }}>
                <ErrorOutlineIcon style={{ color: "#593687", fontSize: 32 }} />
                <p style={{ margin: 0, paddingLeft: 16, fontWeight: 500, fontSize: 20 }}>{header}</p>
            </Grid>
            <Grid container item xs={12} style={{ marginLeft: 40}}>
                <Grid container item xs={12} style={{ paddingInline: 8, flexWrap: "nowrap" }}>
                    {message.map((entity, index) => (
                        <React.Fragment key={index}>
                            <Grid container item style = {{ padding: 10, flexDirection: "column", gap: 4, width: "auto", flex: "1 1 0" }}>
                                <p style={{ margin: 0, fontWeight: 600, fontSize: 16 }}>{entity.entity_name}</p>
                                <a href={entity.info_url} 
                                    target="_blank" 
                                    rel="noopener noreferrer" 
                                    style={{ color: "#593687", fontWeight: 700, wordBreak: "break-word", fontSize: 14 }}>
                                    {entity.info_url_display}
                                    <OpenInNewIcon style={{ fontSize: 16, verticalAlign: "middle" }} />
                                </a>
                            </Grid>

                            {index < message.length - 1 && (
                                <Grid item style={{ borderLeft: "2px solid #593687", height: "100%", margin: "0 16px" }} />
                            )}
                        </React.Fragment>
                    ))}
                </Grid>
                <hr style={{ width: "100%", borderColor: "#593687" }} />
            </Grid>
            <Grid container item xs={12} style={{ marginLeft: 48 }}>
                <p style={{ margin: 0 }}>{footer}</p>
            </Grid>
        </Grid>
    )
}

export default CountryRedirectCard;